export default __webpack_public_path__ + "static/media/Line.3d361d66.svg";